import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArchive = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-archive-icon lucide-archive",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 5,
			x: 2,
			y: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" }),
		/* @__PURE__ */ _jsx("path", { d: "M10 12h4" })
	]
});
export default SvgArchive;
